


























import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import DialogComponent from '@/components/dialog.component.vue';

@Component({
  components: {
    DialogComponent,
  },
})
export default class BlanksWrongAnswersDialog extends mixins() {
  @Prop(Array) readonly wrongAnswers!: string[];

  showWrongAnswersDialog = false;

  @Watch('wrongAnswers', { deep: true })
  onWrongAnswersChange() {
    if (this.wrongAnswers && Array.isArray(this.wrongAnswers) && this.wrongAnswers.length) {
      this.showWrongAnswersDialog = true;
    }
  }

  close(): void {
    this.showWrongAnswersDialog = false;
    this.$emit('close');
  }
}
